import logoSrc from 'images/branding/skyeer/logo.png'
import style from './SkyeerLayout.module.css'
import clsx from 'clsx'
import LanguageSwitcher from 'components/LanguageSwitcher/LanguageSwitcher'
import { useTranslation } from 'react-i18next'

const SkyeerLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { t } = useTranslation()

  return (
    <div className={style.wrapper}>
      <div className={style.languageSwitcher}>
        <LanguageSwitcher />
      </div>
      <div className={clsx(style.column, style.columnLeft)}>
        <div className={clsx(style.description, style.descriptionFirst)}>{t('signin_page.monitoring_title')}</div>
        <div className={style.description}>{t('signin_page.platform_description')}</div>
      </div>
      <div className={style.column}>
        <img className={style.logoImg} src={logoSrc} alt="logo" />
        {children}
      </div>
    </div>
  )
}

export default SkyeerLayout
